(function () {
  'use strict';
  const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const timePattern = /^([01]\d|2[0-3]):[0-5]\d$/;
  function validate(rows) {
    const errors = [];
    const schedule = new Map();
    if (!Array.isArray(rows) || !rows.length) return {errors: ['Add the hours rows in Store details.'], schedule};
    rows.forEach((row, index) => {
      if (!row || !Array.isArray(row.weekdays) || !row.weekdays.length) {
        errors.push(`Row ${index + 1}: select its weekdays.`);
        return;
      }
      if (row.closed != null && typeof row.closed !== 'boolean') errors.push(`Row ${index + 1}: set Closed to Yes or No.`);
      if (row.closed !== true && (!timePattern.test(row.opens || '') || !timePattern.test(row.closes || '') || row.closes <= row.opens)) {
        errors.push(`Row ${index + 1}: enter opening and closing times as HH:MM, with closing later than opening.`);
      }
      row.weekdays.forEach(day => {
        if (!weekdays.includes(day)) errors.push(`Row ${index + 1}: select a valid weekday.`);
        else if (schedule.has(day)) errors.push(`${day} appears in more than one hours row.`);
        else schedule.set(day, row);
      });
    });
    const missing = weekdays.filter(day => !schedule.has(day));
    if (missing.length) errors.push(`Add hours or Closed for ${missing.join(', ')}.`);
    return {errors, schedule};
  }
  function formatTime(value) {
    const [hours, minutes] = value.split(':').map(Number);
    return `${hours % 12 || 12}${minutes ? `:${String(minutes).padStart(2, '0')}` : ''}`;
  }
  function today(rows, now = new Date()) {
    const {errors, schedule} = validate(rows);
    if (errors.length) return {text: null, errors};
    try {
      const day = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Detroit', weekday: 'long'}).format(now);
      const row = schedule.get(day);
      return {text: row.closed ? 'Closed today.' : `Today: ${formatTime(row.opens)}–${formatTime(row.closes)}.`, errors};
    } catch (_) {
      return {text: null, errors: ['The current Michigan day could not be determined.']};
    }
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {validate, today, formatTime};
  if (typeof document === 'undefined') return;
  function refresh() {
    document.querySelectorAll('[data-ntp-hours]').forEach(element => {
      const target = element.querySelector('[data-ntp-hours-today]');
      if (!target) return;
      if (!target.dataset.fallback) target.dataset.fallback = target.textContent;
      let result;
      try { result = today(JSON.parse(element.dataset.ntpHours)); }
      catch (_) { result = {text: null, errors: ['The hours rows could not be read.']}; }
      target.textContent = result.text || target.dataset.fallback;
      element.dataset.ntpHoursState = result.text ? 'today' : 'weekly-fallback';
      const warning = element.closest('.announcement-bar__message')?.querySelector('[data-ntp-hours-warning]');
      if (warning) {
        warning.hidden = !result.errors.length;
        warning.textContent = result.errors.length ? `Store hours need attention: ${result.errors.join(' ')} The phone header is using the weekly summary.` : '';
      }
    });
  }
  refresh();
  // Re-evaluate an open tab at midnight, after sleep, and after editor section reloads.
  setInterval(() => { if (!document.hidden) refresh(); }, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
